import { Alert, ConfigProvider } from "antd";
import { useCallback, useMemo, useState } from "react";
import ReactDOM from "react-dom";

import { AlertContext } from "./AlertContext";
import type { AlertInfoModel, AlertType } from "./types";

export const AlertProvider = ({ children }: { children: any }) => {
  const [alertInfo, setAlertInfo] = useState<AlertInfoModel>({
    visible: false,
    message: "",
    description: "",
    type: "info",
    icon: undefined,
  });

  const showAlert = useCallback((message: string, description?: string, type?: AlertType, icon?: React.ReactNode) => {
    setAlertInfo({
      visible: true,
      message,
      description,
      type,
      icon,
    });
    setTimeout(() => handleAlertClose(), 3000);
  }, []);

  const handleAlertClose = useCallback(() => {
    setAlertInfo({
      ...alertInfo,
      visible: false,
    });
  }, []);

  const value = useMemo(() => {
    return {
      showAlert,
    };
  }, [showAlert]);

  return (
    <ConfigProvider theme={configTheme}>
      <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
      {alertInfo.visible &&
        ReactDOM.createPortal(
          <Alert
            afterClose={handleAlertClose}
            className="absolute bottom-4 right-4 z-[1200] max-w-[23rem]"
            closable
            description={alertInfo.description}
            icon={alertInfo.icon}
            message={alertInfo.message}
            showIcon
            type={alertInfo.type}
          />,
          document.body
        )}
    </ConfigProvider>
  );
};

// 避免不必要的渲染
const configTheme = {
  components: {
    Alert: { borderRadiusLG: 2, defaultPadding: "8px 16px" },
  },
};
